import React, { useEffect, useState } from 'react';
import { trackPromise } from 'react-promise-tracker';
import Header from "../../commons/Header/Header";
import Footer from "../../commons/Footer/Footer";
import GLobalLinks from "../GLobalLinks/GLobalLinks";
import axios from 'axios';
import './About.css';

const About = (props) => {

  let path = props.path;
  const [content, setContent] = useState([]);
  useEffect(() => {
    let url = `${process.env.REACT_APP_API_ROOT}page/?path=${path}`;
    trackPromise(
      axios.get(url).then((res) => {
        const { data } = res;
        data.cssclass = data.title.toLowerCase().split(" ").join("-");
        setContent(data);
    }));
  }, [path]);

  useEffect(() => {
    const handleTabClick = (e) => {
      e.preventDefault();
      document.querySelectorAll('.nav-link').forEach(link => link.classList.remove('active'));
      e.currentTarget.classList.add('active');

      const id = e.currentTarget.getAttribute('href');
      document.querySelectorAll('.tab-pane').forEach(tab => tab.classList.remove('active'));
      document.querySelector(id)?.classList.add('active');
    };

    const handleAccordionClick = (e) => {
      e.preventDefault();
      const button = e.currentTarget;
      const targetId = button.getAttribute('data-target');
      document.querySelectorAll('.accordion-header button').forEach(btn => {
        if (btn !== button) btn.classList.add('collapsed');
      });
      button.classList.toggle('collapsed');

      document.querySelectorAll('.collapse').forEach(div => {
        if (div.id !== targetId.replace('#', '')) div.classList.remove('show');
      });

      const target = document.querySelector(targetId);
      if (target) target.classList.toggle('show');
    };

    const links = document.querySelectorAll('.mainDiv .nav-link');
    const buttons = document.querySelectorAll('.accordion-header button');

    links.forEach(link => link.addEventListener('click', handleTabClick));
    buttons.forEach(btn => btn.addEventListener('click', handleAccordionClick));

    // Cleanup
    return () => {
      links.forEach(link => link.removeEventListener('click', handleTabClick));
      buttons.forEach(btn => btn.removeEventListener('click', handleAccordionClick));
    };
  }, [content]); // Rerun when content changes

  return (
    <>
      <Header en={GLobalLinks[path]['en']} fr={GLobalLinks[path]['fr']} lang={GLobalLinks[path]['lang']} />
      <div className="container mainDiv ab">
        <div className="row">
          <div className="col-xs-12 content">
            <h1 className={content.cssclass}>{content.title}</h1>
            <div dangerouslySetInnerHTML={{__html:content.html}}>
            </div>
          </div>
        </div>
      </div>
      <Footer lang={GLobalLinks[path]['lang']} />
    </>
  );
}

export default About;
